/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { connect } from 'react-redux'
import { ApplicationState, ProductState } from '../store/interfaces';

import { Finalscreen } from '../components/Finalscreen'
import { configRemoveProduct, configSendFetch, configSetBasics, configStoreFetch, configUpdateProduct, uiGoTo, uiSetMobileOrderStep } from '../store/actions';
import { isMobile } from 'react-device-detect';

const mapStateToProps = (state: ApplicationState) => {
    return {
        ui: state.ui,
        config: state.config,
        library: state.library
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onUiGoTo: (route: string) => {
            dispatch(uiGoTo(route));
        },
        onUiSetMobileOrderStep: (step: string) => {
            dispatch(uiSetMobileOrderStep(step));
        },
        onConfigSetBasics: (basics: boolean) => {
            dispatch(configSetBasics(basics));
            dispatch(configStoreFetch());
        },
        onConfigSend: (lang: string) => {
            dispatch(configSendFetch(lang));
            //if(isMobile) {
            //    dispatch(uiSetMobileOrderStep('post'));
            //    dispatch(uiGoTo('editscreen'));
            //} else {
            //    dispatch(uiGoTo('postscreen'));
            //}
        },
        onProductUpdate: (index: number, state: ProductState) => {
            dispatch(configUpdateProduct(index, state));
            dispatch(configStoreFetch());
        },
        onProductRemove: (index: number) => {
            dispatch(configRemoveProduct(index));
            dispatch(configStoreFetch());
        }
    }
}

const FinalscreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Finalscreen)

export default FinalscreenContainer